const lbaPolicyCodeSelect = angular.module('app.lbaPolicyCodeSelect', []);

lbaPolicyCodeSelect.controller('lbaPolicyCodeSelectCtrl', require('./lbaPolicyCodeSelectCtrl'));
lbaPolicyCodeSelect.directive('lbaPolicyCodeSelect', require('./lbaPolicyCodeSelectDir'));

export default lbaPolicyCodeSelect;



// WEBPACK FOOTER //
// ./src/components/lbaPolicyCodeSelect/index.js